import styled from "styled-components";

const widthLessSideNav = "85%";

export const ProductReviewContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ProductReviewContent = styled.div`
  position: fixed;
  width: ${widthLessSideNav};
  height: 78%;
  top: 22%;
  overflow-y: scroll;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ProductReviewIframe = styled.div`
  width: 100%;
  border: none;
  margin: 0;
  padding: 0;
`;
